import { useState } from 'react';
import { CaptionButton } from '~/shared/components/ui/Button/CaptionButton';
import { ManualReminderDialog } from '~/shared/components/ui/';

export const UISampleManualReminderDialogs = () => {
  const [result, setResult] = useState('');
  const [isShowConfirm, setIsShowConfirm] = useState(false);
  const [isClickable, setClickable] = useState(true);

  return (
    <div className="categories">
      <h3 id="dialog">手動催促ダイアログ</h3>
      <div className="input-line">
        <div className="item-group-100">
          <div className="w-33">
            <CaptionButton
              buttonType="basic"
              caption="確認する"
              name=""
              onClick={() => {
                setResult('');
                setIsShowConfirm(true);
              }}
            />
            <ManualReminderDialog
              isOpen={isShowConfirm}
              onDecision={(v) => {
                setResult(
                  `出力しました。${v.reminderMessageType}${v.reminderMessage}`
                );
                setIsShowConfirm(false);
              }}
              onCancel={() => {
                setResult('キャンセルしました');
                setIsShowConfirm(false);
              }}
              isClickableState={isClickable}
              onChangeClickableState={setClickable}
            />
          </div>
          <div className="w-66">
            <pre className="output">{result}</pre>
          </div>
        </div>
      </div>
    </div>
  );
};
